import { render, staticRenderFns } from "./blessdialog.vue?vue&type=template&id=e8ba00a0&scoped=true"
import script from "./blessdialog.vue?vue&type=script&lang=js"
export * from "./blessdialog.vue?vue&type=script&lang=js"
import style0 from "./blessdialog.vue?vue&type=style&index=0&id=e8ba00a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8ba00a0",
  null
  
)

export default component.exports